import gql from 'graphql-tag'

export const GET_ORGANIZATION_ORDER_ITEM_TEMPLATES = gql`
  query GetOrganizationOrderItemTemplates($organizationSlug: String!) {
    getOrganizationOrderItemTemplates(organizationSlug: $organizationSlug) {
      name
      price
      currency
      venueSection
      venueId
    }
  }
`
export const GET_ORGANIZATION_ORDER_ITEM_TEMPLATES_AND_VENUES = gql`
  query GetOrganizationOrderItemTemplatesAndVenues($organizationSlug: String!) {
    getOrganizationOrderItemTemplates(organizationSlug: $organizationSlug) {
      id
      name
      price
      currency
      venueSection
      venueId
      membership
      prepaidCoupon
      ticketSeller
      salesChannel
      isAccessible
      orderItems {
        id
        initialQuantity
        prepaidCoupon
        quantity
        membership
      }
      venue {
        id
        name
      }
    }
    getOrganizationVenues(organizationSlug: $organizationSlug) {
      id
      publicName
      type
      organizationVenues {
        venueId
        venue {
          id
          name
          seats
          predefinedSections
        }
      }
    }
  }
`
export const GET_ORGANIZATION_ORDER_ITEM_TEMPLATES_AND_VENUES_AND_SEARCH = gql`
  query GetOrganizationOrderItemTemplatesAndVenuesAndSearch(
    $organizationSlug: String!
    $pagination: Pagination
    $searchTerm: String
    $includeArchived: Boolean
  ) {
    getOrganizationOrderItemTemplatesAndSearch(
      organizationSlug: $organizationSlug
      pagination: $pagination
      searchTerm: $searchTerm
      includeArchived: $includeArchived
    ) {
      count
      rows {
        id
        name
        price
        currency
        venueSection
        venueId
        createdAt
        membership
        prepaidCoupon
        ticketSeller
        salesChannel
        isAccessible
        hasSoldOrderItems
        archivedAt
        venue {
          id
          name
        }
      }
    }
  }
`
export const GET_ORGANIZATION_VENUES_FOR_TICKET_TYPES = gql`
  query GetOrganizationVenuesForTicketTypes($organizationSlug: String!) {
    getOrganizationVenues(organizationSlug: $organizationSlug) {
      organizationVenues {
        venue {
          id
          name
          predefinedSections
        }
      }
    }
  }
`
export const GET_ORGANIZATION_ORDER_ITEM_TEMPLATES_AND_VENUES_AND_PROMO_CODES = gql`
  query GetOrganizationOrderItemTemplatesAndVenuesAndPromoCodes(
    $organizationSlug: String!
    $includeArchived: Boolean
  ) {
    getOrganizationOrderItemTemplates(
      organizationSlug: $organizationSlug
      includeArchived: $includeArchived
    ) {
      id
      name
      price
      currency
      venueSection
      venueId
      membership
      prepaidCoupon
      ticketSeller
      salesChannel
      isAccessible
      archivedAt
      orderItems {
        id
        initialQuantity
        prepaidCoupon
        quantity
        membership
      }
      venue {
        id
        name
      }
    }
    getOrganizationVenues(organizationSlug: $organizationSlug) {
      id
      publicName
      type
      organizationVenues {
        venueId
        venue {
          id
          name
          seats
          predefinedSections
        }
      }
    }
    getAllOrganizationPromoCodes(organizationSlug: $organizationSlug) {
      id
      name
    }
  }
`
export const CREATE_ORGANIZATION_ORDER_ITEM_TEMPLATES = gql`
  mutation CreateOrganizationOrderItemTemplates(
    $organizationSlug: String!
    $orderItemTemplateInput: OrderItemTemplateInput!
  ) {
    createOrganizationOrderItemTemplates(
      organizationSlug: $organizationSlug
      orderItemTemplateInput: $orderItemTemplateInput
    ) {
      id
      name
      price
    }
  }
`
export const UPDATE_ORGANIZATION_ORDER_ITEM_TEMPLATES = gql`
  mutation UpdateOrganizationOrderItemTemplates(
    $organizationSlug: String!
    $orderItemTemplateInput: OrderItemTemplateInput!
  ) {
    updateOrganizationOrderItemTemplates(
      organizationSlug: $organizationSlug
      orderItemTemplateInput: $orderItemTemplateInput
    ) {
      id
      name
      price
    }
  }
`
export const ARCHIVE_ORGANIZATION_ORDER_ITEM_TEMPLATE = gql`
  mutation ArchiveOrganizationOrderItemTemplate(
    $organizationSlug: String!
    $orderItemTemplateId: ID!
  ) {
    archiveOrganizationOrderItemTemplate(
      organizationSlug: $organizationSlug
      orderItemTemplateId: $orderItemTemplateId
    ) {
      id
      archivedAt
    }
  }
`
export const UNARCHIVE_ORGANIZATION_ORDER_ITEM_TEMPLATE = gql`
  mutation UnarchiveOrganizationOrderItemTemplate(
    $organizationSlug: String!
    $orderItemTemplateId: ID!
  ) {
    unarchiveOrganizationOrderItemTemplate(
      organizationSlug: $organizationSlug
      orderItemTemplateId: $orderItemTemplateId
    ) {
      id
      archivedAt
    }
  }
`
export const DELETE_ORGANIZATION_ORDER_ITEM_TEMPLATES = gql`
  mutation DeleteOrganizationOrderItemTemplates(
    $organizationSlug: String!
    $orderItemTemplateId: ID!
  ) {
    deleteOrganizationOrderItemTemplates(
      organizationSlug: $organizationSlug
      orderItemTemplateId: $orderItemTemplateId
    )
  }
`
